import { Link } from "react-router-dom";

export function Logo({ compact = false, inverse = false }: { compact?: boolean; inverse?: boolean }) {
  return (
    <Link className={`brand ${compact ? "brand--compact" : ""} ${inverse ? "brand--inverse" : ""}`} to="/" aria-label="AdRoyalties home">
      <img src="/brand/logo.svg" alt="AdRoyalties" />
    </Link>
  );
}
